var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 3.5C17.7091 3.5 19.5 5.29086 19.5 7.5V17.5C19.5 19.7091 17.7091 21.5 15.5 21.5H8.5C6.29086 21.5 4.5 19.7091 4.5 17.5V7.5C4.5 5.29086 6.29086 3.5 8.5 3.5M15.5 3.5C15.5 4.05228 15.0523 4.5 14.5 4.5H9.5C8.94772 4.5 8.5 4.05228 8.5 3.5M15.5 3.5C15.5 2.94772 15.0523 2.5 14.5 2.5H9.5C8.94772 2.5 8.5 2.94772 8.5 3.5M7.5 8.5H16.5M7.5 11.5H16.5M7.5 14.5H11.5",
    stroke: "#E01E00",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.53793adafe031428227fe897df95dfb8.svg";
export { ForwardRef as ReactComponent };